export const NEW_SECONDARY_COLOR = '#F8A503';

export const NON_THEME_COLORS = {
  blue: '#1976D2',
  green: '#388E3C',
  orange: '#F57C00',
  purple: '#7B1FA2',
  pink: '#C2185B',
  teal: '#00796B',
  deepPurple: '#5E35B1',
  gray: '#757575',
};
